import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _ExpAdditionalDataFactory;
/* eslint-disable */
/**
 * Expression Service
 * An API for Expression services, supporting the Expression Editor and Expression Evaluation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech) (v6.0.1).
 *
 * Do not edit the class manually.
 */

// InputSpec (yaml) file: /var/jenkins_home/workspace/V4-5-1-global-pipeline-all-web-products-build/webcommons/abweb/openapi/internal/typescript/target/openapi/openapi//abwebinternal/expressionservice.yaml
// Template file: models.mustache (typescript-fetch)

/**
 * 
 * @export
 * @interface ExpAdditionalData
 */

export class ExpAdditionalDataFactory {}
_ExpAdditionalDataFactory = ExpAdditionalDataFactory;
_defineProperty(ExpAdditionalDataFactory, "FromJSON", function (json) {
  return _ExpAdditionalDataFactory.FromJSONTyped(json, false);
});
_defineProperty(ExpAdditionalDataFactory, "FromJSONTyped", function (json, ignoreDiscriminator) {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    'type': json['type'],
    'values': json['values']
  };
});
_defineProperty(ExpAdditionalDataFactory, "ToJSON", function (value) {
  return _ExpAdditionalDataFactory.ToJSONTyped(false, value);
});
_defineProperty(ExpAdditionalDataFactory, "ToJSONTyped", function (ignoreDiscriminator, value) {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    'type': value.type,
    'values': value.values
  };
});
//# sourceMappingURL=ExpAdditionalData.js.map
